import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from './services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class StockGuard implements CanActivate {

  constructor(private authService: AuthService, private router: Router) {  }
  
  canActivate() {
    if (this.authService.isStoreMan()) return true;

    this.authService.goLogin();
  }

}
